module.exports = __webpack_public_path__ + "static/media/drop.dbc6475a.jpg";